import React, { Component } from 'react'
import getItemsByFilter from '../functions/getItemsByFilter'
import queryString from 'query-string'
import getFilterStrings from '../functions/getFilterStrings';
import { trackUiOverviewFilter } from '../tracking';
import movieFilterMixin from '../mixins/movieFilterMixin';
import { MULTICINEMA } from '../constants/multiCinemaModes';
import getMomentNow from '../functions/getMomentNow';
import setMomentDateObjZero from '../functions/setMomentDateObjZero';
import getItemsBySearch from '../functions/getItemsBySearch';

const hasFilter = WrappedComponent => {
    class HasFilter extends Component {
        constructor(props) {
            super(props)

            this.state = {
                allItems: {},
                activeFilters: {},
                filterDisplay: '',    
                dayFilterDisplay: '',
                openFilter: false,
                openDayFilter: false,
                filterWasSetViaRedirect: false,
                globalAttributes: pmkinoFrontVars.apiData.attributes ? pmkinoFrontVars.apiData.attributes : {}
            }

            this.setActiveFilters = this.setActiveFilters.bind(this)
            this.setAllItems = this.setAllItems.bind(this)
            this.toggleFilter = this.toggleFilter.bind(this)
            this.toggleDayFilter = this.toggleDayFilter.bind(this)
        }

        componentDidMount() {

            if(this.props.location.search !== '') {
                const queryStringValues = queryString.parse(this.props.location.search)
                this.setActiveFilters(queryStringValues)
            } 

            this.setState({
                filterDisplay: pmkinoFrontVars.cinemaData.theme.overview_filter,
                dayFilterDisplay: pmkinoFrontVars.cinemaData.theme.overview_dayfilter
            })

        }

        componentDidUpdate(prevProps, prevState) {    
            if(prevProps.location.search !== this.props.location.search) {
                if(this.props.location.search === '' && !this.state.filterWasSetViaRedirect) {
                    this.setState({
                        filterWasSetViaRedirect: true
                    })
                }

                const queryStringValues = queryString.parse(this.props.location.search)

                this.setSearchFilter(queryStringValues)
                this.setActiveFilters(queryStringValues)
            }

            if( _.difference(this.props.moviesOrder, prevProps.moviesOrder).length !== 0 || _.isEmpty(this.state.allItems)) {
                const { movies, moviesOrder, routesData } = this.props
                const queryStringValues = queryString.parse(this.props.location.search)

                this.setAllItems(movies, moviesOrder, routesData) 
                this.setSearchFilter(queryStringValues)
            }
        }

        toggleFilter() { 
            this.setState({
                openFilter: !this.state.openFilter
            })
        }

        toggleDayFilter() { 
            this.setState({
                openDayFilter: !this.state.openDayFilter
            })
        }
        
        setActiveFilters(queryStringValues) {
            const activeFilters = this.getActiveFilters(queryStringValues)

            trackUiOverviewFilter('Programm', activeFilters)
    
            this.setState({activeFilters})
        }


        setSearchFilter(queryStringValues) {
            if(queryStringValues.search) {
                const { movies } = this.props
                const results = getItemsBySearch(movies, [queryStringValues.search])

                this.setState(prevState => ({
                    allItems: {
                        ...prevState.allItems,
                        searchFilter: {
                            items: results
                        }
                    }
                }))
            } else {
                this.setState(prevState => ({
                    allItems: {
                        ...prevState.allItems,
                        searchFilter: {
                            items: []
                        }
                    }
                }))
            }
        }
    
        setAllItems(movies, moviesOrder, routesData) {
            const { translation, cinemaDataFront } = this.props
            const {hidden_attributes, hide_theatres, show_seatclasses_array} = cinemaDataFront
            const { globalAttributes } = this.state
            const allItems = getItemsByFilter(movies, moviesOrder, routesData, globalAttributes, hide_theatres, translation, hidden_attributes, show_seatclasses_array)

            this.setState({
                allItems: allItems
            })
        }

        render() {
            const {allItems, openFilter, filterDisplay, dayFilterDisplay, activeFilters, openDayFilter, filterWasSetViaRedirect} = this.state
            const { moviesOrder, movies, activeCinema, currentCinemaPk, cinemas, clusterCinemaOption, translation, ignoreAttributesForPerformanceFilter} = this.props
            const { timezone } = translation
            if(!timezone) {
                return ''
            }
            const today = setMomentDateObjZero(getMomentNow(timezone))
            const currentCinema = currentCinemaPk ? cinemas[currentCinemaPk] : null
            const currentCinemaType = currentCinema ? currentCinema.scope.type : null
            const clusterCinemaActive = (clusterCinemaOption || currentCinemaType === MULTICINEMA) && currentCinemaPk === activeCinema ? true : false
            const queryStringValues = queryString.parse(location.search)
            const { filters, dayFilters, searchFilter } = allItems
            const items = this.getItems(filters, dayFilters, searchFilter, activeFilters, moviesOrder, movies, activeCinema, clusterCinemaActive, today, timezone, ignoreAttributesForPerformanceFilter)
            const filterStrings = getFilterStrings(queryStringValues)

            const injectedProps = {
                allItems: allItems,
                items: items,
                filters: filters,
                filterStrings: filterStrings,
                activeFilters: activeFilters,
                dayFilters: dayFilters,
                openDayFilter: openDayFilter,
                searchFilter: searchFilter,
                queryStringValues: queryStringValues,
                toggleFilter: this.toggleFilter,
                toggleDayFilter: this.toggleDayFilter,
                openFilter: openFilter,
                filterDisplay: filterDisplay,
                dayFilterDisplay: dayFilterDisplay,
                filterWasSetViaRedirect: filterWasSetViaRedirect
            }

            return <WrappedComponent
                {...this.props}
                {...injectedProps}
            />
        }
    }

    Object.assign(HasFilter.prototype, movieFilterMixin)

    return HasFilter
}




export default hasFilter